import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ConfirmationDialog from 'components/system/ConfirmationDialog';
import { useModalContext } from 'components/system/ModalContext';
import useAvatarRemove from 'hooks/useAvatarRemove';

const AvatarRemovalConfirmation = ({ onConfirm, onCancel, onClose }) => (
  <ConfirmationDialog
    title="Remove Avatar"
    onCancel={onCancel}
    onClose={onClose}
    onConfirm={onConfirm}
    confirmText="Remove"
    reversed
  >
    <Typography variant="body2">
      Are you sure you want to remove your avatar?
    </Typography>
  </ConfirmationDialog>
);

const AvatarRemoveButton = () => {
  const { openModal, closeModal } = useModalContext();
  const { mutate: removeAvatar } = useAvatarRemove();

  const handleRemoveConfirm = async () => {
    removeAvatar();
  };

  const handleDeleteClick = () => {
    openModal({
      content: (
        <AvatarRemovalConfirmation
          onCancel={closeModal}
          onClose={closeModal}
          onConfirm={handleRemoveConfirm}
        />
      ),
    });
  };

  return (
    <Button onClick={handleDeleteClick} className="avatarAction">
      Remove photo
    </Button>
  );
};

export default AvatarRemoveButton;
